import styled from 'styled-components';

import { Box, Button, Stack, Typography } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

import MessageDialogs from 'images/message-dialogs.svg';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${wellzTheme.spacing(4, 1)};
`;

export const Illustration = styled(MessageDialogs)`
  margin-bottom: ${wellzTheme.spacing(5)};
`;

export const Title = styled(Typography).attrs({ variant: 'h6' })`
  margin-bottom: ${wellzTheme.spacing(3)};
`;

export const ContentContainer = styled(Stack).attrs({ spacing: 2 })`
  width: 100%;
  padding: ${wellzTheme.spacing(0, 2)};
`;

export const Subtitle = styled(Typography).attrs({ variant: 'body1' })``;

export const SubtitleStyle = styled(Typography).attrs({
  variant: 'body2',
  color: 'text.secondary',
})``;

export const MessagePreviewContainer = styled(Box)`
  flex: 1;
  border-radius: ${wellzTheme.shape.borderRadius * 2}px;
  background-color: ${wellzTheme.palette.action.disabledBackground};
  padding: ${wellzTheme.spacing(2)};
`;

export const MessagePreviewText = styled(Typography).attrs({
  variant: 'body2',
  color: 'text.secondary',
})``;

export const SubmitButton = styled(Button).attrs({
  variant: 'contained',
  size: 'large',
})`
  margin-top: ${wellzTheme.spacing(4)};

  ${wellzTheme.breakpoints.down('md')} {
    width: 100%;
    margin-top: ${wellzTheme.spacing(5)};
  }
`;
